import React, { Component } from 'react'
import i18n from 'simple-react-i18n'
import { connect } from 'react-redux'
import HomeAction from '../../../home/actions/HomeAction'
import Card from '../../../components/card/Card'
import Input from '../../../components/forms/Input'
import RadioButtons from '../../../components/forms/RadioButtons'
import { getLogin, getSettingJson } from '../../../utils/SettingUtils'
import { getLabel } from '../../../utils/StoreUtils'
import DtoPiezometerLight from '../../../piezometry/dto/DtoPiezometerLight'
import DtoMapSituation from './dto/DtoMapSituation'
import PiezometryAction from '../../../piezometry/actions/PiezometryAction'
import PropTypes from 'prop-types'
import { Button, Dialog, DialogActions, DialogContent, Grid, IconButton, Stack, Tooltip } from '@mui/material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { getExecStatusIcon, getExecStatusLabel } from '../../../utils/JobUtils'
import { CardTable } from 'components/datatable/NewTable'
import { setActions } from '../../../components/ActionUtil'
import moment from 'moment'
import { push } from '@lagunovsky/redux-react-router'
import { nbPerPageLabel } from '../../../referencial/constants/ReferencialConstants'
import ProgressBar from '../../../components/progress/ProgressBar'
import { getFullDateMini } from '../../../utils/DateUtil'
import { searchAllCharacters } from '../../../utils/StringUtil'
import { getFrequencyStatDefaultParams, getFrequencyStatsDialog } from './paramsDialog/FrequencyStatDialog'
import StationAction from '../../actions/StationAction'
import { isNil, maxBy, orderBy, uniq } from 'lodash'
import { getIPSDefaultParams, getIPSDialog } from './paramsDialog/IPSDialog'
import {
    getThresholdIndicatorDefaultParams,
    getThresholdIndicatorDialog,
} from './paramsDialog/ThresholdIndicatorDialog'
import DtoHydrometricStation from '../../../hydrometry/dto/DtoHydrometricStation'
import HydrometryAction from '../../../hydrometry/actions/HydrometryAction'
import DtoParametrageDataType from '../../../piezometry/dto/DtoParametrageDataType'
import { execByType } from '../../../utils/StationUtils'
import Checkbox from '../../../components/forms/Checkbox'
import { getOndeDialog, getOndesDefaultParams } from './paramsDialog/OndeDialog'
import MultiContributorsAutocomplete from 'referencial/components/contributor/components/MultiContributorsAutocomplete'
import ContributorItem from 'referencial/components/contributor/dto/ContributorItem'
import User from 'account/dto/User'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import PluviometerDto from '../../../pluviometry/dto/PluviometerDto'
import PluviometryAction from '../../../pluviometry/actions/PluviometryAction'
import AccountAction from '../../../account/actions/AccountAction'
import DtoAccountSettings from '../../../account/dto/DtoAccountSettings'
import { darkBlue } from 'utils/constants/ColorTheme'
import ProgressCard from 'components/card/ProgressCard'
import ConfirmModal from 'components/modal/ConfirmModal'

const STEP = {
    STATIONS: 0,
    STATS: 1,
    TREND: 2,
    CALCULATE: 3,
}

const INDICATOR = {
    IPS: 1,
    THRESHOLD: 2,
    FREQUENCY_STAT: 3,
    ONDE: 4,
}

const MAP_STATUS = {
    WAITING: 0,
    SUCCESS: 1,
    ERROR: 2,
    WARNING: 3,
    NOTHING_TO_DO: 4,
}

// Statut de la carte -> statut d'exécution de traitement, pour reprendre les icônes des traitements
const JOB_STATUS_BY_MAP_STATUS = {
    [MAP_STATUS.SUCCESS]: 1,
    [MAP_STATUS.ERROR]: 0,
    [MAP_STATUS.WARNING]: 2,
    [MAP_STATUS.NOTHING_TO_DO]: 4,
}

const getCalculationDate = ms => {
    if (ms.status === MAP_STATUS.WAITING) {
        return <ProgressBar progress={ms.progress} withMessage/>
    }
    const execution = { status: JOB_STATUS_BY_MAP_STATUS[ms.status] }
    return (
        <Stack direction='row' spacing={1} alignItems='center'>
            {(!isNil(ms.date) || !isNil(ms.jobExecutionId)) && !isNil(execution.status) && getExecStatusIcon(execution, 20, getExecStatusLabel(execution))}
            <span>{getFullDateMini(ms.date)}</span>
        </Stack>
    )
}

class MapSituationAdminApp extends Component {
    constructor(props) {
        super(props)
        this.st = (window.location.href || document.URL).split('#')[1].split('/')[1]
        this.state = {
            dataLoaded: false,
            searchValue: '',
            paramsDialogIsOpen: false,
            deleteDialogIsOpen: false,
            msSelected: {},
            step: STEP.STATIONS,
            newMapDialogIsOpen: false,
            networkLinks: [],
            contributorsSelected: [],
        }
        this.hasQuit = false
        this.INDICATOR_LIST = (() => {
            switch (this.st) {
                case 'piezometry':
                    return [
                        {
                            code: INDICATOR.IPS,
                            name: i18n.piezometerSPI,
                        },
                        {
                            code: INDICATOR.THRESHOLD,
                            name: i18n.thresholdsIndicators,
                        },
                        {
                            code: INDICATOR.FREQUENCY_STAT,
                            name: i18n.frequencyStats,
                        },
                    ]
                case 'hydrometry':
                    return [
                        // {
                        //     code: INDICATOR.IPS,
                        //     name: i18n.piezometerSPI,
                        // },
                        {
                            code: INDICATOR.THRESHOLD,
                            name: i18n.thresholdsIndicators,
                        },
                        {
                            code: INDICATOR.FREQUENCY_STAT,
                            name: i18n.frequencyStats,
                        },
                        {
                            code: INDICATOR.ONDE,
                            name: 'ONDE',
                        },
                    ]
                case 'pluviometry':
                    return [
                        {
                            code: INDICATOR.THRESHOLD,
                            name: i18n.thresholdsIndicators,
                        },
                        {
                            code: INDICATOR.FREQUENCY_STAT,
                            name: i18n.frequencyStats,
                        },
                    ]
                default:
                    return []
            }
        })()
    }

    setTitle = () => {
        this.props.setTitle([{
            title: i18n[this.st],
            href: `${this.st}`,
        }, {
            title: i18n.mapSituations,
            href: `${this.st}/mapSituations`,
        }, {
            title: i18n.parameters,
            href: `${this.st}/mapSituations/settings`,
        }])
    }

    componentWillUnmount() {
        setActions({})
        this.hasQuit = true
    }

    componentDidMount() {
        this.setTitle()
        execByType(this.st, {
            piezometry: () => {
                if (!this.props.piezometers.length) {
                    this.props.fetchPiezometers()
                }
                if (!this.props.piezometryDataTypes.length) {
                    this.props.fetchPiezometryDataTypes()
                }
                PiezometryAction.promiseNetworkPiezoLink().then(links => this.setState({ networkLinks: links }))
            },
            hydrometry: () => {
                if (!this.props.hydrometricStations.length) {
                    this.props.fetchHydrometricStations()
                }
                if (!this.props.hydrometryDataTypes.length) {
                    this.props.fetchHydrometryDataTypes()
                }
            },
            pluviometry: () => {
                if (!this.props.pluviometers.length) {
                    this.props.fetchPluviometers()
                }
                if (!this.props.pluviometryDataTypes.length) {
                    this.props.fetchPluviometryDataTypes()
                }
            },
        })
        this.props.fetchMapSituations(this.st).then(() => {
            this.setState({ dataLoaded: true })
            if (this.props.mapSituations.find(ms => ms.status === MAP_STATUS.WAITING)) {
                this.setAutoReload()
            }
        })
        setActions({
            new: () => this.setState({
                newMapDialogIsOpen: true,
                step: STEP.STATIONS,
                msSelected: {
                    id: 0,
                    indicatorType: INDICATOR.FREQUENCY_STAT,
                    calculType: 'now',
                    startPeriod: moment().valueOf(),
                    endPeriod: moment().valueOf(),
                    recurrence: 'day',
                    status: 1,
                    typeId: -1,
                },
            }),
        })
    }

    onSave = (launch = false) => {
        const ms = {
            ...this.state.msSelected,
            updateLogin: getLogin(),
        }
        this.props.updateMapSituation(this.st, ms, launch).then(() => {
            this.setState({ paramsDialogIsOpen: false })
            this.setAutoReload()
        })
    }

    setAutoReload = () => {
        if (!this.hasQuit) {
            setTimeout(() => {
                this.props.fetchMapSituations(this.st).then(() => {
                    if (this.props.mapSituations.find(ms => ms.status === MAP_STATUS.WAITING)) {
                        this.setAutoReload()
                    }
                })
            }, 5000)
        }
    }

    getStations = () => {
        return execByType(this.st, {
            piezometry: () => this.props.piezometers,
            hydrometry: () => this.props.hydrometricStations,
            pluviometry: () => this.props.pluviometers,
        })
    }

    getParamsDialog = () => {
        const { contributors } = this.props
        const { msSelected, paramsDialogIsOpen } = this.state
        if (!paramsDialogIsOpen) {
            return null
        }
        switch (msSelected.indicatorType) {
            case INDICATOR.IPS:
                return getIPSDialog(this.state, changes => this.setState(changes), this.onSave, this.getStations(), this.getDataTypes(), this.st, contributors)
            case INDICATOR.THRESHOLD:
                return getThresholdIndicatorDialog(this.state, changes => this.setState(changes), this.onSave, this.getStations(), this.getDataTypes(), this.st, contributors)
            case INDICATOR.ONDE:
                return getOndeDialog(this.state, changes => this.setState(changes), this.onSave, this.getStations(), this.getDataTypes(), this.st, contributors)
            default:
                return getFrequencyStatsDialog(this.state, changes => this.setState(changes), this.onSave, this.getStations(), this.getDataTypes(), this.st, contributors)
        }
    }

    getDefaultParams = () => {
        switch (this.state.msSelected.indicatorType) {
            case INDICATOR.IPS:
                return getIPSDefaultParams()
            case INDICATOR.THRESHOLD:
                return getThresholdIndicatorDefaultParams()
            case INDICATOR.ONDE:
                return getOndesDefaultParams()
            default:
                return getFrequencyStatDefaultParams()
        }
    }

    getDataTypes = () => execByType(this.st, {
        piezometry: () => this.props.piezometryDataTypes,
        hydrometry: () => this.props.hydrometryDataTypes,
        pluviometry: () => this.props.pluviometryDataTypes,
        // installation: () => this.props.installationDataTypes,
        default: () => [],
    })

    onSaveNew = () => {
        this.setState({ newMapDialogIsOpen: false })
        const msSelected = { ...this.state.msSelected, params: JSON.stringify(this.getDefaultParams()) }
        this.props.createMapSituation(this.st, msSelected).then(() => {
            this.props.fetchMapSituations(this.st).then(() => {
                const newMap = maxBy(this.props.mapSituations, 'updateDate')
                this.setState({ msSelected: newMap, paramsDialogIsOpen: true })
            })
        })
    }

    getNewMapDialog = () => {
        const { newMapDialogIsOpen, msSelected } = this.state
        if (!newMapDialogIsOpen) {
            return null
        }
        const change = changes => this.setState({ msSelected: { ...msSelected, ...changes } })
        return (
            <Dialog
                onClose={() => this.setState({ newMapDialogIsOpen: false })}
                fullWidth
                maxWidth='lg'
                open={newMapDialogIsOpen}
                classes='no-padding'
                scroll='body'
            >
                <DefaultDialogTitle title={i18n.mapSituationNew} onClose={() => this.setState({ newMapDialogIsOpen: false })} />
                <DialogContent>
                    <Grid container spacing={1}>
                        <Grid size={6}>
                            <Input
                                title={ i18n.name }
                                onChange={ v => change({ name: v }) }
                                value={ msSelected.name }
                            />
                        </Grid>
                        <Grid size={6}>
                            <RadioButtons
                                activeOneBelowOther={true}
                                elements={this.INDICATOR_LIST}
                                title={i18n.mapType}
                                selected={msSelected.indicatorType}
                                onChange={ (v) => change({ indicatorType: v }) }
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.onSaveNew} variant='contained' color='primary'>
                        {i18n.save}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    changeDefault = (ms) => {
        const previous = this.props.mapSituations.find(m => m.default)
        if (previous) {
            this.props.updateMapSituation(this.st, { ...previous, default: false }, false).then(() => {
                this.props.updateMapSituation(this.st, { ...ms, default: true }, false).then(() => {
                    this.props.fetchMapSituations(this.st)
                })
            })
        } else {
            this.props.updateMapSituation(this.st, { ...ms, default: true }, false).then(() => {
                this.props.fetchMapSituations(this.st)
            })
        }
    }

    changeWidgetOnDashboard = (ms) => {
        const obj = getSettingJson(this.props.accountUserSettings, 'MAP_SITUATION_DASHBOARD_WIDGET') ?? {}
        const key = `${this.st}-${ms.id}`
        const newObj = {
            ...obj,
            [key]: !obj[key],
        }
        this.props.updateOrCreateSetting(getLogin(), 'MAP_SITUATION_DASHBOARD_WIDGET', JSON.stringify(newObj))
    }

    render() {
        const { contributors, accountUser, mapSituations, accountUserSettings } = this.props
        const { contributorsSelected, dataLoaded, searchValue, deleteDialogIsOpen, msSelected } = this.state
        this.st = (window.location.href || document.URL).split('#')[1].split('/')[1]
        if (!dataLoaded) {
            return <div style={{ padding: '5px' }}><ProgressCard round indeterminate /></div>
        }

        const dashboardWidgetObj = getSettingJson(accountUserSettings, 'MAP_SITUATION_DASHBOARD_WIDGET') ?? {}
        const contributorsSituations = uniq(mapSituations.map(m => m.contributorCode).filter(c => c))
        const contributorsFiltered = contributors.filter(c => contributorsSituations.includes(c.code))
        const mapSituationsByContributors = contributorsSelected?.length ? mapSituations.filter(m => contributorsSelected.includes(m.contributorCode)) : mapSituations
        const data = orderBy(mapSituationsByContributors, 'id').filter(m => (!m.contributorCode || accountUser.isAdmin === '1' || (m.contributorCode === accountUser.contributorCode)) && searchAllCharacters(m.name).includes(searchAllCharacters(searchValue))).map(ms => {
            const dashboardWidgetKey = `${this.st}-${ms.id}`
            const params = JSON.parse(ms.params)
            return {
                ms,
                name: { value: ms.name },
                nbStats: { value: params.stats?.length || 0 },
                nbStations: {
                    value: params.allStations ? i18n.allFP : params.stationIds.length,
                    sortValue: params.allStations ? Infinity : params.stationIds.length,
                },
                nbValues: {
                    value: ms.nbValues === 0 ? i18n.noResults : ms.nbValues,
                    sortValue: ms.nbValues,
                },
                date: {
                    value: getCalculationDate(ms),
                    sortValue: ms.date,
                },
                type: { value: getLabel(this.INDICATOR_LIST, ms.indicatorType) },
                editBy: { value: ms.updateLogin },
                update: {
                    value: getFullDateMini(ms.updateDate),
                    sortValue: ms.updateDate,
                },
                nullValue2: {
                    value: !isNil(ms.jobExecutionId) && !isNil(ms.jobId) && (
                        <Tooltip title={i18n.accessToJob}>
                            <IconButton size='small' onClick={() => this.props.push(`/import/${ms.jobId}?jobExecutionId=${ms.jobExecutionId}`)}>
                                <OpenInNewIcon fontSize='small'/>
                            </IconButton>
                        </Tooltip>
                    ),
                },
                displayByDefault: {
                    value: <Checkbox checked={ms.default} onChange={ v => v ? this.changeDefault(ms) : null }/>,
                    sortValue: !!ms.default,
                },
                administrator: {
                    value: contributors.find(c => c.code === ms.contributorCode)?.name || '',
                },
                widgetOnDashboard: {
                    value: <Checkbox checked={dashboardWidgetObj[dashboardWidgetKey]} onChange={ () => this.changeWidgetOnDashboard(ms) }/>,
                    sortValue: !!dashboardWidgetObj[dashboardWidgetKey],
                },
            }
        })
        return (
            <Grid container spacing={1} direction='column' alignItems='stretch' sx={{ padding: '5px 5px 100px 5px' }}>
                <Card className='padding-1' round>
                    <Grid container spacing={1}>
                        <Grid size={3}>
                            <Input
                                title={i18n.search}
                                value={searchValue}
                                onChange={v => this.setState({ searchValue: v })}
                            />
                        </Grid>
                        <Grid size={3}>
                            <MultiContributorsAutocomplete
                                label={i18n.administrator}
                                options={contributorsFiltered}
                                multiple
                                onChange={v => this.setState({ contributorsSelected: v })}
                            />
                        </Grid>
                    </Grid>
                </Card>
                <CardTable
                    title={i18n.mapSituations}
                    rows={data}
                    rowsPerPageOptions={nbPerPageLabel}
                    headers={['nullValue', 'type', 'name', 'nbStats', 'nbStations', 'date', 'nbValues', 'editBy', 'update', 'displayByDefault', 'widgetOnDashboard', 'administrator', 'nullValue2']}
                    lineActions={[
                        {
                            icon: 'clear',
                            onClick: (s) => this.setState({ deleteDialogIsOpen: true, msSelected: s.ms }),
                        },
                        {
                            icon: 'edit',
                            onClick: (s) => this.setState({ paramsDialogIsOpen: true, msSelected: s.ms, step: STEP.STATIONS }),
                        },
                        {
                            icon: 'play_circle_outline',
                            onClick: (s) => this.props.launchMapSituation(this.st, s.ms.id).then(this.setAutoReload),
                        },
                    ]}
                    color={darkBlue}
                />
                { this.getParamsDialog() }
                { this.getNewMapDialog() }
                <ConfirmModal
                    isOpen={deleteDialogIsOpen}
                    onValidate={() => {
                        this.props.deleteMapSituation(this.st, msSelected).then(() => this.props.fetchMapSituations(this.st))
                        this.setState({ deleteDialogIsOpen: false, msSelected: undefined })
                    }}
                    onClose={() => this.setState({ deleteDialogIsOpen: false, msSelected: undefined })}
                />
            </Grid>
        )
    }
}

MapSituationAdminApp.propTypes = {
    mapSituations: PropTypes.arrayOf(PropTypes.instanceOf(DtoMapSituation)),
    fetchMapSituations: PropTypes.func,
    deleteMapSituation: PropTypes.func,
    launchMapSituation: PropTypes.func,
    setTitle: PropTypes.func,
    updateOrCreateSetting: PropTypes.func,
    push: PropTypes.func,
    piezometers: PropTypes.arrayOf(PropTypes.instanceOf(DtoPiezometerLight)),
    hydrometricStations: PropTypes.arrayOf(PropTypes.instanceOf(DtoHydrometricStation)),
    pluviometers: PropTypes.arrayOf(PropTypes.instanceOf(PluviometerDto)),
    updateMapSituation: PropTypes.func,
    createMapSituation: PropTypes.func,
    fetchPiezometers: PropTypes.func,
    fetchHydrometricStations: PropTypes.func,
    fetchPluviometers: PropTypes.func,
    piezometryDataTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoParametrageDataType)),
    hydrometryDataTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoParametrageDataType)),
    pluviometryDataTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoParametrageDataType)),
    fetchPiezometryDataTypes: PropTypes.func,
    fetchHydrometryDataTypes: PropTypes.func,
    fetchPluviometryDataTypes: PropTypes.func,
    contributors: PropTypes.arrayOf(PropTypes.instanceOf(ContributorItem)),
    accountUser: PropTypes.instanceOf(User),
    accountUserSettings: PropTypes.arrayOf(PropTypes.instanceOf(DtoAccountSettings)),
}

const mapStateToProps = store => ({
    mapSituations: store.StationReducer.mapSituations,
    piezometers: store.PiezometryReducer.piezometersLight,
    hydrometricStations: store.HydrometryReducer.hydrometricStations,
    pluviometers: store.PluviometryReducer.pluviometers,
    piezometryDataTypes: store.PiezometryReducer.piezometryDataTypes,
    hydrometryDataTypes: store.HydrometryReducer.hydrometryDataTypes,
    pluviometryDataTypes: store.PluviometryReducer.pluviometryDataTypes,
    contributors: store.ContributorReducer.contributors,
    accountUser: store.AccountReducer.accountUser,
    accountUserSettings: store.AccountReducer.accountUserSettings,
})

const mapDispatchToProps = {
    setTitle: HomeAction.setTitle,
    updateOrCreateSetting: AccountAction.updateOrCreateSetting,
    fetchMapSituations: StationAction.fetchMapSituations,
    deleteMapSituation: StationAction.deleteMapSituation,
    launchMapSituation: StationAction.launchMapSituation,
    createMapSituation: StationAction.createMapSituation,
    updateMapSituation: StationAction.updateMapSituation,
    fetchPiezometers: PiezometryAction.fetchPiezometersLight,
    fetchHydrometricStations: HydrometryAction.fetchHydrometricStations,
    fetchPluviometers: PluviometryAction.fetchPluviometers,
    push,
    fetchPiezometryDataTypes: PiezometryAction.fetchPiezometryDataTypes,
    fetchHydrometryDataTypes: HydrometryAction.fetchHydrometryDataTypes,
    fetchPluviometryDataTypes: PluviometryAction.fetchPluviometryDataTypes,

}

export default connect(mapStateToProps, mapDispatchToProps)(MapSituationAdminApp)
